export default "__VITE_ASSET__2d46e0e1__"